import _isNil from "lodash/isNil";
import Modality from 'const/enums/Modality';
import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';
import getImmuneModality from 'redux/selectors/experimentSettings/getImmuneModality';
var getImmuneCellSet = function getImmuneCellSet() {
  return function (state) {
    var _state$cellSets$prope, _state$cellSets$prope2;
    var immuneModality = getImmuneModality()(state.experimentSettings);
    if (_isNil(immuneModality)) return null;
    var immuneYesKey = immuneModality === Modality.TCR ? 'tcr-yes' : 'bcr-yes';
    return (_state$cellSets$prope = (_state$cellSets$prope2 = state.cellSets.properties) === null || _state$cellSets$prope2 === void 0 ? void 0 : _state$cellSets$prope2[immuneYesKey]) !== null && _state$cellSets$prope !== void 0 ? _state$cellSets$prope : null;
  };
};
export default createMemoizedSelector(getImmuneCellSet);